import { isLocalhost } from "@gtmhub/env";

export interface IAuthCookieValue {
  state: string;
  nonce: string;
  appState?: Record<string, string>;
}

export class AuthCookie {
  constructor(private domain: string, private secure: boolean, private isMsTeamsState: boolean) {}

  set(value: IAuthCookieValue, opts: { maxAgeInSecs: number }): void {
    const cookieParts = [
      "a0s=" + encodeURIComponent(value ? JSON.stringify(value) : ""),
      "domain=" + (isLocalhost(this.domain) ? this.domain : "gtmhub.com"),
      "max-age=" + opts.maxAgeInSecs,
    ];

    if (this.isMsTeamsState) {
      cookieParts.push("SameSite=None");
    }

    if (this.secure) {
      cookieParts.push("secure=true");
    }

    document.cookie = cookieParts.join("; ");
  }

  getAndRemove(): IAuthCookieValue {
    const stateCookies = (document.cookie || "").split("; ").filter(function (cookie) {
      return cookie.indexOf("a0s=") === 0;
    });
    if (!stateCookies.length) {
      return null;
    }

    const value = decodeURIComponent(stateCookies[0].split("=")[1]);
    if (!value) {
      return null;
    }

    this.set(null, { maxAgeInSecs: -1 });
    return JSON.parse(value) as IAuthCookieValue;
  }
}

export class AuthSpaJsCookie {
  static readonly cookieKeyPrefix = "a0.spajs.txs"; // taken from auth0-spa-js
  static readonly cookieDomain = "gtmhub.com";
  // This method replaces the domain of the cookie from auth0-spa-js library
  // The transactionManager in the auth0-spa-js library ignores the Auth0ClientOptions.cookieDomain parameter
  // Which prevents us from using cross-subdomain cookis (between app.staging.gtmhub.com and myaccount.staging.gtmhub.com)
  // So we're patching the library's cookie until there is a fix for the library
  static patchCookieDomain(domain: string, auth0ClientId: string): void {
    if (isLocalhost(domain)) {
      // no need to patch on localhost
      return;
    }
    const cookieKey = this.cookieKeyPrefix + "." + auth0ClientId;
    // get the cookie
    const auth0SpaJsCookie = (document.cookie || "").split("; ").filter((cookie) => {
      return cookie.indexOf(cookieKey) === 0;
    });
    if (auth0SpaJsCookie.length == 0) {
      // no cookie set, so nothing to patch
      return;
    }

    const valueStartIndex = auth0SpaJsCookie[0].indexOf("=") + 1;
    const value = decodeURIComponent(auth0SpaJsCookie[0].substring(valueStartIndex));

    // remove current cookie
    this.remove(auth0ClientId);

    // set new auth0-spa-js cookie value
    const maxAgeInSecs = 10 * 60; // 10mins
    const cookieParts = [cookieKey + "=" + value, "domain=" + this.cookieDomain, "max-age=" + maxAgeInSecs, "secure=true"];
    document.cookie = cookieParts.join("; ");
  }

  static remove(auth0ClientId: string): void {
    const cookieKey = this.cookieKeyPrefix + "." + auth0ClientId;
    const cookieToBeDeleted = [cookieKey + "=", "domain=" + this.cookieDomain, "max-age=-1"];
    document.cookie = cookieToBeDeleted.join("; ");
  }
}
